import React, { useState, useEffect, useCallback, useMemo, useContext } from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import ListLayout from '../../Generic/ListLayout';
import DataTable from '../../Generic/DataTable';
import confirmDeleteDialog from '../../Generic/confirmDeleteDialog';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import useDeleteItem from '../../../hooks/useDeleteItem';
import useFilterData from '../../../hooks/useFilterData';
import useFetchData from '../../../hooks/useFetchData';
import useLocalizedTextsMap from '../../../hooks/useLocalizedTextsMap';
import { useSetMenu } from "../../../hooks/useSetMenu";
import { createGeneralColumn, createActiveColumn, createActionColumn } from '../../Generic/dataGridColumns';
import AuthContext from "../../../context/AuthProvider";
const List = () => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useContext(AuthContext);
  const { mainStore, panelStore } = useStore();
  const { t } = useTranslation();
  const localizedTextsMap = useLocalizedTextsMap();
  useSetMenu(mainStore.PanelMenuType, mainStore.PanelMenuNo);
  const [columns, setColumns] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  //FetchData and Search


  useFetchData(axiosPrivate, `/Panels`, panelStore);
  const filteredData = useFilterData(toJS(panelStore.panel), searchQuery);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  //Delete
  const deletePanel = useDeleteItem(axiosPrivate, '/Panels', panelStore.deletePanel);

  const remove = useCallback((id) => {
    confirmDeleteDialog(t, deletePanel, id);
  }, [deletePanel, t]);

  const cols = useMemo(() => [
    createGeneralColumn("name", "panel", t, 180),
    createActiveColumn(t),
    createActionColumn(t,"/Panel/Edit",remove),
    // eslint-disable-next-line
  ].filter(Boolean), [t, remove]);

  useEffect(() => {
    setColumns(cols);
    // eslint-disable-next-line
  }, [t]);

  return (
    <>
      <ListLayout
        title={t("panelListTitle")}
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        searchPlaceholder={t("searchPlaceholder")}
        addButtonLink="/Panel/Add"
        addButtonTitle={t("add")}
      >
        <DataTable
          rows={filteredData}
          columns={columns}
          pageSize={pageSize}
          setPageSize={setPageSize}
          localeTextsMap={localizedTextsMap}
        />
      </ListLayout>
    </>
  );
};

export default observer(List);